import {
  arbitrum,
  base,
  baseSepolia,
  ChainId,
  mainnet,
  optimism,
  sepolia,
  zora,
  zoraSepolia,
} from '@ourzora/chains'
import { cleanAddress, LowercaseAddress } from '../../addresses'
import { abi } from './abi'

export const Multicall = {
  abi,
  address: {
    [mainnet.id]: cleanAddress(mainnet.contracts.multicall3.address),
    [sepolia.id]: cleanAddress(sepolia.contracts.multicall3.address),
    [zora.id]: cleanAddress(zora.contracts.multicall3.address),
    [zoraSepolia.id]: cleanAddress(zoraSepolia.contracts.multicall3.address),
    [base.id]: cleanAddress(base.contracts.multicall3.address),
    [baseSepolia.id]: cleanAddress(baseSepolia.contracts.multicall3.address),
    [optimism.id]: cleanAddress(optimism.contracts.multicall3.address),
    [arbitrum.id]: cleanAddress(arbitrum.contracts.multicall3.address),
  } satisfies Record<ChainId, LowercaseAddress>,
} as const
